import React from "react";
import { ReactComponent as ReactLogo } from "../../icons/reacticon.svg";
import { ReactComponent as TailwindLogo } from "../../icons/tailwind.svg";
import { ReactComponent as HtmlLogo } from "../../icons/html5.svg";
import { ReactComponent as CssLogo } from "../../icons/css-5.svg";
import { ReactComponent as JavascriptLogo } from "../../icons/javascript.svg";
import { ReactComponent as GitLogo } from "../../icons/git-icon.svg";
import { ReactComponent as GithubLogo } from "../../icons/github-icon.svg";
import { ReactComponent as NodeJSLogo } from "../../icons/node-js-logo.svg";
import { ReactComponent as MongoDBLogo } from "../../icons/mongodb-icon-1.svg";
import { ReactComponent as ExpressLogo } from "../../icons/express-109.svg";
import { ReactComponent as GsapLogo } from "../../icons/gsap.svg";
import { ReactComponent as SassLogo } from "../../icons/sass-1.svg";
import { ReactComponent as JsonLogo } from "../../icons/json.svg";
import { ReactComponent as NpmLogo } from "../../icons/npm.svg";
import { ReactComponent as PostmanLogo } from "../../icons/getpostman-icon.svg";
import { ReactComponent as FirebaseLogo } from "../../icons/firebase-1.svg";

const Skills = () => {
  return (
    <div className="2xl:p-40 sm:p-20 pt-20 px-10 w-full h-screen sm:overflow-y-hidden overflow-y-scroll overflow-x-hidden">
      <h1 className="sm:text-4xl text-center  text-3xl pb-8 text-yellow-50 font-bold">
        Skills
      </h1>
      <ul className="max-w-xl mx-auto flex p-1 justify-evenly mt-1 text-center">
        <div className="flex flex-col gap-1 justify-center">
          <ReactLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">React</li>
        </div>
        <div className="flex flex-col gap-1 justify-center">
          <TailwindLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">Tailwind</li>
        </div>
        <div className="flex flex-col gap-1 justify-center">
          <HtmlLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">HTML5</li>
        </div>
        <div className="flex flex-col gap-1 justify-center">
          <CssLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">CSS3</li>
        </div>
        <div className="flex flex-col gap-1 justify-center">
          <JavascriptLogo className="w-7 h-7 mx-auto" />
          <li
            className="text-lg
           p-1 pointer-events-none"
          >
            JavaScript
          </li>
        </div>
      </ul>
      <ul className="max-w-xl mx-auto flex p-1 mt-4 justify-evenly">
        <div className="flex flex-col gap-1 justify-center">
          <GithubLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">Github</li>
        </div>
        <div className="flex flex-col gap-1 justify-center">
          <GitLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">Git</li>
        </div>

        <div className="flex flex-col gap-1 justify-center">
          <NodeJSLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">NodeJS</li>
        </div>
      </ul>
      <p className="pt-10 text-3xl w-full border-b border-yellow-100 pointer-events-none"></p>
      <ul className="sm:max-w-md max-w-full mx-auto flex sm:gap-x-5 p-1 py-2 mt-4 justify-evenly text-center flex-wrap">
        <div className="flex flex-col w-20 gap-1  justify-center">
          <MongoDBLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">MongoDB</li>
        </div>
        <div className="flex flex-col w-20 gap-1 justify-center">
          <ExpressLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">Express</li>
        </div>

        <div className="flex flex-col w-20 gap-1 justify-center">
          <SassLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">Sass</li>
        </div>
        <div className="flex flex-col w-20 gap-1 justify-center">
          <JsonLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">JSON</li>
        </div>
        <div className="flex flex-col w-20 gap-1 justify-center">
          <GsapLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">GSAP</li>
        </div>

        <div className="flex flex-col w-20 gap-1 justify-center">
          <NpmLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">npm</li>
        </div>
        <div className="flex flex-col w-20 gap-1 justify-center">
          <PostmanLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">Postman</li>
        </div>
        <div className="flex flex-col w-20 gap-1 justify-center">
          <FirebaseLogo className="w-7 h-7 mx-auto" />
          <li className="text-lg p-1 pointer-events-none">Firebase</li>
        </div>
      </ul>
    </div>
  );
};

export default Skills;
